import { Text } from "ui/Typography"
import { GROUP_COLORS } from "constants/clients"
import styles from "./index.module.css"
import { useTranslation } from "react-i18next"
import { Button, Tag, Flex, Input, Space } from "antd"
import PropTypes from "prop-types"

const GroupForm = ({
  newName,
  handleNameChange,
  addGroupValidation,
  selectedColor,
  setSelectedColor,
  handleCancelEdit,
  handleSaveGroup
}) => {
  const { t } = useTranslation()
  return (
    <Space direction="vertical" className="w-full p-xs">
      <Text className="fw-500">Group Name <span className={styles.requiredSign}>*</span></Text>
      <Input placeholder="Group name" value={newName} minLength={1} maxLength={50} onChange={handleNameChange} autoFocus />
      {addGroupValidation.nameMessage && <Text type="danger">{addGroupValidation.nameMessage}</Text>}
      <Text className="fw-500">Color <span className={styles.requiredSign}>*</span></Text>
      <Flex wrap className={styles.colorTag} gap={16}>
        {GROUP_COLORS.map((color) => (
          <button
            key={color}
            onClick={(e) => {
              e.stopPropagation()
              setSelectedColor(color)
            }}
            className={`align-center justify-center p-0 ${selectedColor === color ? styles.selected : ""}`}
            style={{ border: "none", background: "none" }}
          >
            <Tag
              color={color}
              style={{
                outline: selectedColor === color ? `2px solid #1D72F4` : "none"
              }}
              className={`m-0 ${styles.groupColorTag}`}
            />
          </button>
        ))}
      </Flex>
      {addGroupValidation.colorMessage && <Text type="danger">{addGroupValidation.colorMessage}</Text>}
      <Flex gap={8} className={styles.clientButtonGroup}>
        <Button onClick={handleCancelEdit}>{t("global.cancel")}</Button>
        <Button type="primary" onClick={handleSaveGroup}>
          {t("global.save")}
        </Button>
      </Flex>
    </Space>
  )
}

GroupForm.propTypes = {
  newName: PropTypes.string,
  handleNameChange: PropTypes.func,
  addGroupValidation: PropTypes.shape({
    name: PropTypes.bool,
    color: PropTypes.bool,
    nameMessage: PropTypes.string,
    colorMessage: PropTypes.string,
    message: PropTypes.string
  }),
  selectedColor: PropTypes.string,
  setSelectedColor: PropTypes.func,
  handleCancelEdit: PropTypes.func,
  handleSaveGroup: PropTypes.func
}

export default GroupForm
